import { render, staticRenderFns } from "./coursePreview.vue?vue&type=template&id=4b7fd7a3&scoped=true"
import script from "./coursePreview.vue?vue&type=script&lang=js"
export * from "./coursePreview.vue?vue&type=script&lang=js"
import style0 from "./coursePreview.vue?vue&type=style&index=0&id=4b7fd7a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7fd7a3",
  null
  
)

export default component.exports